import type { RootStack } from "../NavigatorScreen";

import MyActivityHistory from "./MyActivityHistory";
import MyActivityManageRequest from "./MyActivityManageRequest";
import MyActivityScreen from "./MyActivityScreen";

export default function MyActivityGroup(Stack: RootStack) {
  return (
    <>
      <Stack.Group>
        <Stack.Screen
          name="MyActivity"
          component={MyActivityScreen}
          options={({ route }) => ({
            title: route.params.name,
          })}
        />

        <Stack.Screen
          name="MyActivityManageRequest"
          component={MyActivityManageRequest}
          options={{
            title: "Manage Request",
            headerShadowVisible: true,
          }}
        />

        <Stack.Screen
          name="MyActivityHistory"
          component={MyActivityHistory}
          options={{
            title: "My Activities",
            headerShadowVisible: false,
          }}
        />
      </Stack.Group>
    </>
  );
}
